import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { FlexRow, FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import * as cartSrc from '../../../../assets/zemplin/cart--large.svg';
import * as arrowSrc from '../../../../assets/zemplin/arrow-triangle.svg';
import { SvgIcon } from '../../Zemplin/General/SvgIcon';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  disabled?: boolean;
}

function ButtonWithRequest({ onButtonClick, onRequestClick, disabled }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Wrapper>
      <CartButton disabled={disabled} type="button" onClick={onButtonClick}>
        <IconImg
          disabled={disabled}
          cursor={'pointer'}
          src={cartSrc.toString()}
          alt="Pridať do košíka"
        />
      </CartButton>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  position: relative;
  justify-content: flex-end;
  margin-left: ${rem(8)};
  min-width: ${rem(64)};
`;

const CartButton = styled(Button)`
  background-color: #339933};
  border-radius: ${rem(2)} 0px 0px ${rem(2)};
  padding: ${rem(12)};
  margin-right: ${rem(1)};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }
`;

export { ButtonWithRequest };
